import React, {useContext, useState} from "react";
import Dropdown from "./Dropdown";
import Loading from "../../Loading";
import {AppContext} from "../../../App";
import {RoutingHelper} from "../../Navigation/Routing";

export const searchFormDefault = {
    actionType: "",
    types: [],
    cities: [],
    budget: 0,
    minRooms: 0,
    sold: false
};

export const SearchFormContext = React.createContext({
    searchForm: searchFormDefault,
    setSearchForm: (searchForm) => {
        this.searchForm = searchForm;
    }
});

export function copySearchForm(searchForm) {
    return JSON.parse(JSON.stringify(searchForm));
}

function SearchForm(props) {
    const [searchForm, setSearchForm] = useState({
        actionType: props?.params?.actionType ? props.params.actionType : searchFormDefault.actionType,
        types: props?.params?.types ? props.params.types : searchFormDefault.types,
        cities: props?.params?.cities ? props.params.cities : searchFormDefault.cities,
        budget: props?.params?.budget ? props.params.budget : searchFormDefault.budget,
        minRooms: props?.params?.minRooms ? props.params.minRooms : searchFormDefault.minRooms,
        sold: window.location.pathname === "/vendus" ? true : searchFormDefault.sold
    });
    const value = {searchForm, setSearchForm};

    const budgetRanges = [
        {name: "Budget indifférent", value: "0-999999999"},
        {name: "CHF 0.- à CHF 100'000.-", value: "0-100000"},
        {name: "CHF 100'000.- à CHF 200'000.-", value: "100000-200000"},
        {name: "CHF 200'000.- à CHF 300'000.-", value: "200000 - 300000"},
        {name: "CHF 300'000.- à CHF 400'000.-", value: "300000 - 400000"},
        {name: "CHF 400'000.- à CHF 500'000.-", value: "400000 - 500000"},
        {name: "CHF 500'000.- à CHF 600'000.-", value: "500000 - 600000"},
        {name: "CHF 600'000.- à CHF 700'000.-", value: "600000 - 700000"},
        {name: "CHF 700'000.- à CHF 800'000.-", value: "700000 - 800000"},
        {name: "CHF 800'000.- à CHF 900'000.-", value: "800000 - 900000"},
        {name: "CHF 900'000.- à CHF 1'000'000", value: "900000-1000000"},
        {name: "Plus de CHF 1'000'000.-", value: "1000000-999999999"},
    ];

    const minRooms = [
        {name: "Indifférent", value: "0"},
        {name: "1+ pièces", value: "1"}, {name: "1.5+ pièces", value: "1.5"},
        {name: "2+ pièces", value: "2"}, {name: "2.5+ pièces", value: "2.5"},
        {name: "3+ pièces", value: "3"}, {name: "3.5+ pièces", value: "3.5"},
        {name: "4+ pièces", value: "4"}, {name: "4.5+ pièces", value: "4.5"},
        {name: "5+ pièces", value: "5"}, {name: "5.5+ pièces", value: "5.5"},
        {name: "6+ pièces", value: "6"}, {name: "6.5+ pièces", value: "6.5"},
        {name: "7+ pièces", value: "7"}, {name: "7.5+ pièces", value: "7.5"},
    ];

    const {citiesLoading, typesLoading} = useContext(AppContext);
    const cities = JSON.parse(localStorage.getItem("cities"))?.data;
    const types = JSON.parse(localStorage.getItem("types"))?.data;

    const [actionType, setActionType] = useState(searchForm.actionType);

    function updateSearchForm(field, value) {
        let tempSearchForm = copySearchForm(searchForm);

        tempSearchForm[field] = value;

        setSearchForm(tempSearchForm);
    }

    function handleActionTypeChange(e) {
        let currActionType = e.target.checked ? "Acheter" : "Louer";

        setActionType(currActionType);

        updateSearchForm("actionType", currActionType);
    }

    function submitForm() {
        let params = [];

        if (searchForm.actionType !== searchFormDefault.actionType)
            params.push("actionType=" + searchForm.actionType);

        if (searchForm.budget !== searchFormDefault.budget)
            params.push("budget=" + (typeof searchForm.budget === "string" ? searchForm.budget : searchForm.budget.value));

        if (searchForm.cities.length > 0){
            params.push("cities=" + searchForm.cities.map((city) => {
                if (typeof city === "string") {
                    return city;
                } else {
                    return city.postalCode;
                }
            }).join(","));
        }

        if (searchForm.types.length > 0){
            params.push("types=" + searchForm.types.map((type) => {
                if (typeof type === "string") {
                    return type;
                } else {
                    return type.value;
                }
            }).join(","));
        }

        if (searchForm.minRooms && searchForm.minRooms > 0)
            params.push("minRooms=" + searchForm.minRooms);

        params.push("page=1");

        let getParams = "";

        if (params.length > 0)
            getParams = "?" + params.join("&");

        if (!searchForm.sold) {
            window.location.href = RoutingHelper.getPath("recherche") + getParams;
        } else {
            window.location.href = RoutingHelper.getPath("vendus") + getParams;
        }
    }

    return (
        <div className="h-fit">
            <label htmlFor="actionType"
                   className="border border-primary shadow-card relative inline-flex cursor-pointer select-none items-center justify-center rounded-full bg-white p-1 mb-4 gap-x-2">
                <input type="checkbox" name="actionType" id="actionType" checked={actionType === "Acheter"}
                       className="sr-only" value="Acheter" onChange={handleActionTypeChange}/>
                <span
                    className={"transition ease-out text-lg flex items-center rounded-full p-2 " + (actionType === "Acheter" ? "text-white bg-primary" : "text-primary hover:bg-gray-200")}>
                      Acheter
                   </span>
                <span
                    className={"transition ease-out text-lg flex items-center rounded-full p-2 " + (actionType === "Louer" ? "text-white bg-primary" : "text-primary hover:bg-gray-200")}>
                      Louer
                   </span>
            </label>
            {window.location.pathname === "/" ?
                <div
                    className="border border-white shadow-card relative inline-flex cursor-pointer select-none
                   items-center justify-center rounded-full bg-white mb-4 gap-x-2 ml-3">
                    <div
                        className="transition ease-out text-lg flex items-center rounded-full p-2 text-white bg-primary hover:bg-primary-light group">
                        <a className="ml-1 flex items-center" href={RoutingHelper.getPath("estimation")}>
                            Estimation
                            <svg className="w-4 h-4 rotate-90 transition-transform group-hover:rotate-45 mx-2"
                                 aria-hidden="true"
                                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 14">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                      d="M5 13V1m0 0L1 5m4-4 4 4"/>
                            </svg>
                        </a>
                    </div>
                </div>
                : ""}
            <div
                className="flex flex-col md:flex-row divide-y md:divide-y-0 md:divide-x divide-primary md:h-24 mb-2 border border-primary">
                <SearchFormContext.Provider value={value}>
                    <div className="w-full md:w-2/3 h-16 md:h-auto bg-white">
                        {!citiesLoading ?
                            <Dropdown title={"Localité"} name={"cities"} itemList={cities} values={"postalCode"}/>
                            : <Loading page={false}/>}

                    </div>
                    <div className="w-full md:w-2/3 h-16 md:h-auto bg-white">
                        {!typesLoading ?
                            <Dropdown title={"Type"} name={"types"} itemList={types} values={"value"}/>
                            : <Loading page={false}/>}

                    </div>
                    <div className="w-full md:w-2/3 h-16 md:h-auto">
                        <Dropdown type={"radio"} title={"Budget (CHF)"} name={"budget"} itemList={budgetRanges}
                                  values={"value"}/>
                    </div>
                    <div className="w-full md:w-2/3 h-16 md:h-auto">
                        <Dropdown type={"radio"} title={"Pièces"} name={"minRooms"} itemList={minRooms}
                                  values={"value"}/>
                    </div>
                </SearchFormContext.Provider>
                <div className="w-full md:h-full md:w-1/5">
                    <button
                        className="w-full h-16 md:h-full p-3 bg-primary text-white hover:bg-primary-light focus:ring-4 focus:outline-none focus:ring-primary-light group"
                        onClick={submitForm}>
                        <div
                            className="w-full h-full group-hover:rotate-90 transition flex justify-center items-center">
                            <svg className="w-6 h-6" aria-hidden="true"
                                 xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
                            </svg>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SearchForm;